import { useEffect, useState } from "react";
import { Country, State } from "country-state-city";
import { useParams } from "react-router-dom";

import FormButton from "../../form/FormButton";
import FormInput from "../../form/FormInput";
import SelectInput from "../../form/SelectInput";
import useFetchStudentInfo from "../../../api/classes/students/useFetchStudentInfo";
import useUpdateStudentInfo from "../../../api/classes/students/useUpdateStudentInfo";
import Loader from "../../Loader";

const GuardianDetailsForm = () => {
  const { studentId } = useParams();
  const [updateGuardianRequest] = useUpdateStudentInfo();
  const [guardianDetails, loading, fetchGuardianInfo] = useFetchStudentInfo(
    studentId,
    "guardian"
  );
  const [guardian, setGuardian] = useState({});

  useEffect(() => {
    setGuardian(guardianDetails);
  }, [guardianDetails]);

  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedState, setSelectedState] = useState(null);

  async function updateGuardianInfo() {
    if (selectedCountry && !selectedState) {
      const country = Country.getCountryByCode(selectedCountry);
      guardian.nationality = country.name;
    }

    if (selectedCountry && selectedState) {
      const country = Country.getCountryByCode(selectedCountry);
      const state = State.getStateByCodeAndCountry(
        selectedState,
        selectedCountry
      );

      guardian.nationality = country.name;
      guardian.stateOfOrigin = state.name;
    }

    const isSuccessful = await updateGuardianRequest(
      studentId,
      "guardian",
      guardian
    );
    if (isSuccessful) await fetchGuardianInfo(studentId, "guardian");
  }

  const countries = Country.getAllCountries()?.map((country) => ({
    value: country.isoCode,
    ...country,
  }));

  const states = (countryCode) =>
    State.getStatesOfCountry(countryCode).map((state) => ({
      value: state.isoCode,
      ...state,
    }));

  if (loading) return <Loader loading={loading} />;

  return (
    <div className="px-5">
      <h3 className="text-black-text font-semibold mb-5">
        Guardian information
      </h3>

      <div className="grid gap-4 md:grid-cols-2">
        <FormInput
          label={"Last name"}
          value={guardian?.name || ""}
          onChange={(e) =>
            setGuardian({
              ...guardian,
              name: e.currentTarget.value,
            })
          }
        />

        <FormInput
          label={"Email address"}
          value={guardian?.email || ""}
          onChange={(e) =>
            setGuardian({
              ...guardian,
              email: e.currentTarget.value,
            })
          }
        />

        <FormInput
          label={"Home address"}
          value={guardian?.address || ""}
          onChange={(e) =>
            setGuardian({
              ...guardian,
              address: e.currentTarget.value,
            })
          }
        />

        <FormInput
          label={"Contact"}
          value={guardian?.phone || ""}
          maxLength={11}
          onChange={(e) =>
            setGuardian({
              ...guardian,
              phone: e.currentTarget.value,
            })
          }
        />

        <FormInput
          label={"Occupation"}
          value={guardian?.occupation || ""}
          onChange={(e) =>
            setGuardian({
              ...guardian,
              occupation: e.currentTarget.value,
            })
          }
        />

        <SelectInput
          label={"Religion"}
          placeholder="Religion"
          value={guardian?.religion}
          handleSelect={(e) =>
            setGuardian({ ...guardian, religion: e.currentTarget.value })
          }
          options={[
            { name: "Islam", value: "Islam" },
            { name: "Christianity", value: "Christianity" },
            { name: "Other", value: "Other" },
          ]}
        />

        <SelectInput
          label={"Marital status"}
          placeholder="Marital status"
          value={guardian?.maritalStatus}
          handleSelect={(e) =>
            setGuardian({ ...guardian, maritalStatus: e.currentTarget.value })
          }
          options={[
            { name: "Married", value: "Married" },
            { name: "Single", value: "Single" },
            { name: "Divorced", value: "Divorced" },
          ]}
        />

        <SelectInput
          label={`Nationality`}
          placeholder={guardian?.nationality}
          handleSelect={(e) => setSelectedCountry(e.currentTarget.value)}
          options={countries}
        />

        <SelectInput
          label={`State of origin`}
          placeholder={guardian?.stateOfOrigin}
          handleSelect={(e) => setSelectedState(e.currentTarget.value)}
          options={states(selectedCountry)}
        />

        <FormInput
          label={"L.G.A"}
          value={guardian?.lga || ""}
          onChange={(e) =>
            setGuardian({
              ...guardian,
              lga: e.currentTarget.value,
            })
          }
        />

        <FormInput
          label={"Ethnicity"}
          value={guardian?.ethnicity || ""}
          onChange={(e) =>
            setGuardian({
              ...guardian,
              ethnicity: e.currentTarget.value,
            })
          }
        />
      </div>

      <div className="border max-w-xs mx-auto my-10">
        <FormButton
          title={"Update"}
          onClick={updateGuardianInfo}
          loading={loading}
        />

        {/* <div style={{ minWidth: "100px" }} /> */}
      </div>
    </div>
  );
};
export default GuardianDetailsForm;
